import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { useTranslation } from "react-i18next";

const SubUserStatementTableDropdown = ({
  data,
  setSuccess,
  setError,
  setToggleModal,
  setDataModal,
  setLastAction
}) => {
  const { t } = useTranslation();
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);
  
  const statusUpdateBtnText = (data.status === 0) ? t("subuserStatements.view.dropdown.markAsPaid") : t("subuserStatements.view.dropdown.markAsOpen");
  const statusUpdateAction = (data.status === 0) ? "marked as PAID" : "marked as OPEN";

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret outline color="primary">
        {t("subuserStatements.view.dropdown.action")}
      </DropdownToggle>

      <DropdownMenu>
        <DropdownItem
            onClick={() => {
            setSuccess(false);
            setError(false);
            setDataModal(data);
            setToggleModal(true);
            setLastAction(statusUpdateAction);
            }}
            style={{ cursor: "pointer" }}
        >
            {statusUpdateBtnText}
        </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default SubUserStatementTableDropdown;
